module.exports = __webpack_public_path__ + "img/flag-yellow.1438ee83.svg";